<div class="projects-container">
  <!-- Header -->
  <div class="projects-header">
    <h1 class="projects-title">Projects</h1>
    <button class="btn-new-project" nz-button nzType="primary" (click)="openProjectModal()">
      <svg-icon src="assets/icons/plus.svg" svgClass="plus-icon" />
      <span>New Project</span>
    </button>
  </div>

  <!-- Toolbar -->
  <div class="projects-toolbar">
    <div class="search-wrapper">
      <gains-input icon="assets/icons/search.svg" placeholder="Search projects..." [(ngModel)]="searchQuery"></gains-input>
    </div>
    <div class="sort-wrapper">
      <gains-select-2
        selectorIcon="assets/icons/sort-item.svg"
        selectorLabel="Sort by"
        [allowClear]="false"
        [items]="sortOptions"
        [customFormControl]="sortControl"
        placeholder="Recent Activity"
      ></gains-select-2>
    </div>
  </div>

  <!-- Project Failed State, above the list: creating a project adds it optimistically, so projects can
       exist while the loaded list is still unknown. The failure is reported over them, not instead of them. -->
  <deo-panel-state
    *ngIf="loadError && !isLoading"
    mode="error"
    title="Couldn't load projects"
    [message]="loadError"
    [compact]="true"
    [layout]="filteredProjects.length > 0 ? 'banner' : 'block'"
    (retry$)="retryLoad()"
  ></deo-panel-state>

  <!-- Project Cards List -->
  <!-- Hidden rather than left empty: .projects-list is flex: 1, so an empty list would keep the column's
       whitespace and squeeze the failed/empty state below it instead of centring it in the panel. -->
  <div class="projects-list" *ngIf="filteredProjects.length > 0">
    <div
      class="project-card"
      *ngFor="let project of filteredProjects; trackBy: trackByProjectId"
      (click)="selectProject(project)"
      tabindex="0"
      (keydown.enter)="selectProject(project)"
    >
      <div class="card-header">
        <label *ngIf="project.isMine" class="select-check" tabindex="-1" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <input
            type="checkbox"
            [checked]="isProjectSelected(project.id)"
            [attr.aria-label]="'Select project ' + project.name"
            (change)="toggleProjectSelection(project.id, $event)"
            (keydown.enter)="onCheckboxKey($event, project.id)"
            (keydown.space)="onCheckboxKey($event, project.id)"
          />
          <span class="checkmark"></span>
        </label>
        <svg-icon src="assets/icons/projects.svg" class="card-icon project-color-icon" [style.color]="getProjectIconColor(project)"></svg-icon>
        <span class="card-name">{{ project.name }}</span>
        <span class="card-spacer"></span>
        <div class="card-actions" *ngIf="project.isMine">
          <button
            class="card-star"
            type="button"
            [attr.aria-label]="project.starred ? 'Unstar project' : 'Star project'"
            [attr.aria-pressed]="project.starred"
            (keydown)="onCardControlClick($event)"
            (click)="onFavoriteClick($event, project)"
          >
            <svg-icon [src]="project.starred ? 'assets/icons/favorite-filled.svg' : 'assets/icons/favorite.svg'" aria-hidden="true"></svg-icon>
          </button>
          <gains-ellipsis-menu
            class="card-menu"
            [menuItems]="projectMenuItems"
            [dropdownWidth]="'200px'"
            (click)="onCardControlClick($event)"
            (keydown)="onCardControlClick($event)"
            (changeEvent)="onProjectMenuAction($event, project)"
          ></gains-ellipsis-menu>
        </div>
      </div>
      <div class="card-meta">
        <span class="meta-item">
          <svg-icon src="assets/icons/chat.svg" class="meta-icon"></svg-icon>
          {{ project.chats }} chats
        </span>
        <span class="meta-dot">&bull;</span>
        <span class="meta-item">
          <svg-icon src="assets/icons/files-content.svg" class="meta-icon"></svg-icon>
          {{ project.artifacts }} artifact{{ project.artifacts !== 1 ? 's' : '' }}
        </span>
      </div>
      <div class="card-footer">Updated {{ project.updatedLabel }}</div>
    </div>
  </div>
  <!-- Project Empty State -->
  <deo-panel-state
    *ngIf="!loadError && filteredProjects.length === 0 && !isLoading"
    mode="empty"
    icon="assets/icons/chat.svg"
    title="No Project Found"
    [compact]="true"
  ></deo-panel-state>
  <gains-bulk-actions-drawer [selectedItems]="selectedProjectIds">
    <div class="selection-info">
      <span class="selection-count">{{ selectedProjectIds.length }} project{{ selectedProjectIds.length !== 1 ? 's' : '' }} selected</span>
    </div>
    <button nz-button nzType="default" nzDanger (click)="deleteSelectedProjects($event)">
      <svg-icon src="assets/icons/trash-1.svg" title="Delete" />
      Delete
    </button>
  </gains-bulk-actions-drawer>
</div>
